<template>
    <div class="list">
        <NavBar></NavBar>
        <div class="title_top">
            <div class="title_son" style="text-align:center;padding:40px 0">
                <div style="font-size:15px;color:#fff;font-weight:bold;padding:0 20px 10px 20px">{{housename}}</div>
                <div style="font-size:20px;color:#fff;font-weight:bold">余额:{{balance}}元</div>
            </div>
        </div>
        <van-col style="padding:0px 10px;margin-top:50px">
            <van-button type="primary" size="normal" block @click="Recharge">充 值</van-button>
        </van-col>
    </div>
</template>

<script>
export default {
    data() {
      return{
          houseguid:'',
          housename:'',
          balance:'',
      }  
    },
    methods:{
        Recharge(){
            this.$router.push({
                path:'/RechargeList',
                query:{
                    balance:this.balance
                }
            })
        }
    },
    created(){
        this.houseguid = this.$route.query.houseguid
        this.housename = this.$route.query.housename
        this.balance=this.$route.query.balance
    }
}
</script>

<style scoped>
.list{
    margin-top: 46px;
}
.title_top{
    padding:7px;
}
.title_son{
    background: linear-gradient(to right,#9ec6e9,#72bee3);
    /* background-color: #e0e0e0; */
    border-radius: 10px;
}
</style>